import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import { SCTI_COUNTRY_IDS } from 'containers/FastCover/constants';

import injectReducer from 'utils/injectReducer';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import {
  makeSelectStepAppsureBankDetails,
  makeSelectStepAppsureBankDetailsErrors,
  makeSelectBsbValidating,
  makeSelectBsbNotice,
} from './selectors';
import reducer from './reducer';
import messages from './messages';

import WizardNavigationButtons from '../components/WizardNavigationButtons';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import { length, required, maxLength, alphaHyphenOnly, minLength } from '../../../utils/validation/validator';
import Textbox from '../components/Textbox/index';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation/';
import {
  handleFormDataChange,
  nextSlide,
  resetFormRegisterGstState,
  closeBSBNotice,
} from './actions';
import { makeSelectCellCaptiveCountryId, makeSelectPolicyTypeCode, makeSelectIsClaimForFieldEnabled, makeSelectIsShowGstQuestion, makeSelectCellCaptiveName, makeSelectFormHasChanges } from '../../App/selectors';
import { listPolicyTypeForCellCaptivePartnerInsurance } from '../../FastCover/dataMapper/claimCodeMapper';
import OptionsContainer from '../components/OptionsContainer';
import P from '../../../components/P/index';
import { saveFormData } from '../actions';
import { setFormHasChanges } from '../../App/actions';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import { getBank, getBankSuccess } from '../../FastCover/actions';
import ModalNotice from './components/ModalNotice';
import InvalidBSBWarning from './components/InvalidBSBWarning';
import HelpText from '../../../components/HelpText';
import TextArea from '../components/TextArea';
import { LIST_CELLCAPTIVE_NAME } from '../../App/constants';

const alphaOnly = (value) => {
  if (!value) return true;
  return /^[a-zA-Z\s]+$/.test(value.toString().trim());
};

const minLengthAllowEmpty = (len) => {
  function minLenWithEmpty(value) {
    if (value === undefined || value === null || value === '') {
      return true;
    }
    return minLength(len)(value);
  }
  return minLenWithEmpty;
};

const maxLengthAllowEmpty = (len) => {
  function maxLenWithEmpty(value) {
    if (value === undefined || value === null || value === '') {
      return true;
    }
    return maxLength(len)(value);
  }
  return maxLenWithEmpty;
};

export class StepAppsureBankDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      showModal: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.saveButtonId = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
    this.invalidBSBWarning = null;

    this.lastCheckingBSB = props.form.bsbNumber;
    const { bsbNumber = '', institutionNumber = '' } = props.form || {};
    this.lastCheckingTransitInstitution = `${bsbNumber || ''}${institutionNumber || ''}`;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getBankByBsb = (event) => {
    // this.validatorGroup.checkValidation();
    // const isInvalid = this.validatorGroup.checkError('bsbNumber');
    // if (isInvalid === false) {
    const value = event.target.value;
    if (!value) {
      const bankInfo = {
        isBsbValid: false,
        nameOfBank: '',
        branch: '',
        institutionNumber: '',
        bsbCannotBeVerified: false,
      };
      this.props.getBankSuccess(bankInfo);
    } else if (this.lastCheckingBSB !== value) {
      this.lastCheckingBSB = event.target.value;
      this.props.onGetBankByBSB(this.lastCheckingBSB);
    }
    // }
  };

  getBankByTransitAndInstitution = (event) => {
    const { form } = this.props;
    const { name, value } = event.target;
    const currentBsbNumber = name === 'bsbNumber' ? value : form.bsbNumber;
    const currentInstitutionNumber = name === 'institutionNumber' ? value : form.institutionNumber;
    const combinedValue = `${currentBsbNumber || ''}${currentInstitutionNumber || ''}`;

    if (!currentBsbNumber || !currentInstitutionNumber) {
      const bankInfo = {
        isBsbValid: false,
        nameOfBank: '',
        branch: '',
        institutionNumber: '',
        bsbCannotBeVerified: false,
      };
      this.props.getBankSuccess(bankInfo);
      this.lastCheckingTransitInstitution = '';
      return;
    }

    // Check validation before calling API
    const isBsbNumberValid = currentBsbNumber && currentBsbNumber.length === 5;
    const isInstitutionNumberValid = currentInstitutionNumber && currentInstitutionNumber.length === 3;

    // Only call API if both fields pass validation
    if (isBsbNumberValid && isInstitutionNumberValid && this.lastCheckingTransitInstitution !== combinedValue) {
      this.lastCheckingTransitInstitution = combinedValue;
      this.props.onGetBankByBSB(this.lastCheckingTransitInstitution);
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.checkBSBValidation();
    this.handleFormDataSave();
    this.nextButton.focus();
    this.checkFormError();
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
    // this.props.makeDirty(2);
  };

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  checkBSBValidation = () => {
    const { isBsbValid, bsbCannotBeVerified } = this.props.form;
    if (!isBsbValid && !bsbCannotBeVerified) {
      this.showModal();
    }
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }
    // const errors = this.validatorGroup.getErrors();
    this.checkFormError();

    this.handleFormDataSave();
    this.props.next();
    if (document.activeElement) {
      document.activeElement.blur();
    }
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
    this.props.setFormHasChanges(false);
  };

  handleResetPartialFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  closeModal = () => {
    this.setState({ showModal: false });
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  renderRegisterdGSTPurpuseInfo = () => {
    const { isSummary, submitted, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    const { registerForGSTPurpose, abn, percentageOfGST, claimITC } = isSummary
      ? this.summaryFormValue()
      : this.props.form;
    return (
      registerForGSTPurpose === 'true' && (
        <div>
          <div className={'row'}>
            <div className={'col-md-7 form-group'}>
              <Validate
                name="abn"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                fieldName={messages.whatIsYourABN}
              >
                <Textbox
                  disabled={isReadOnly}
                  name="abn"
                  type="number"
                  placeholder=""
                  onChange={this.handleChange('form.abn')}
                  value={abn}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={{ defaultMessage: intl.formatMessage(messages.whatIsYourABN) }}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>

          <div className={'row'}>
            <div className={'col-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.claimITC} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={claimITC === 'true'}
                    onChange={this.handleChange('form.claimITC')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={claimITC === 'false'}
                    onChange={this.handleChange('form.claimITC')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>

          <div className={'row'}>
            <div className={'col-md-7 form-group'}>
              <Validate
                name="percentageOfGST"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                fieldName={messages.whatPercentageOfGST}
              >
                <Textbox
                  disabled={isReadOnly}
                  name="percentageOfGST"
                  type="number"
                  onChange={this.handleChange('form.percentageOfGST')}
                  value={percentageOfGST}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={{ defaultMessage: intl.formatMessage(messages.whatPercentageOfGST) }}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
        </div>
      )
    );
  };

  renderOtherInsuranceDetail() {
    const { isSummary, submitted, intl } = this.props;
    const { otherInsurance, provideDetails } = isSummary
      ? this.summaryFormValue()
      : this.props.form;
    const isReadOnly = submitted || isSummary;
    return (
      otherInsurance === 'true' && (
        <div className={'form-group'}>
          {/* <PageSectionHeader> */}
          {/* <FormattedMessage {...messages.ifYesPleaseProvideDetails} /> */}
          {/* </PageSectionHeader> */}
          <Validate
            name="provideDetails"
            validators={[required]}
            group={this.validatorGroup}
            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
            validChangeInGroup={this.validatorGroup.validChangeInGroup}
            validationCounter={this.state.validationCounter}
            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
            defaultValue={provideDetails}
            fieldName={messages.ifYesPleaseProvideDetails}
          >
            <TextArea
              disabled={isReadOnly}
              name="provideDetails"
              type="text"
              onChange={this.handleChange('form.provideDetails')}
              value={provideDetails}
              isSummary={isSummary}
            />
            <ErrorMessage for="required">
              <FormattedMessage
                {...messages.isRequired}
                values={{ defaultMessage: intl.formatMessage(messages.ifYesPleaseProvideDetails) }}
              />
            </ErrorMessage>
          </Validate>
        </div>
      )
    );
  }

  renderBankDetailsForm() {
    const {
      isSummary,
      submitted,
      bsbValidating,
      cellCaptiveCountryId,
      policyTypeCode,
      isClaimForFieldEnabled,
      isShowGstQuestion,
      intl,
    } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      nameOfBank,
      branch,
      bsbNumber,
      accountNumber,
      accountHolder,
      registerForGSTPurpose,
      otherInsurance,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { bsbCannotBeVerified, isBsbValid } = this.props.form;

    const isPartnerInsurance = listPolicyTypeForCellCaptivePartnerInsurance.includes(policyTypeCode);
    const isFnolNewZealand = cellCaptiveCountryId === SCTI_COUNTRY_IDS.NEW_ZEALAND || isPartnerInsurance;

    const isbsbNumber6Digits = length(6)(bsbNumber);

    const maxAccountNumberLength = isFnolNewZealand ? 10 : 9;
    const isAccountNumberTooLong = maxLength(maxAccountNumberLength)(accountNumber) === false;

    let isAccountNumberTooShort = false;
    if (isFnolNewZealand) {
      isAccountNumberTooShort = minLength(9)(accountNumber) === false;
    }

    const isInvalidAccountHolderFormat = alphaHyphenOnly(accountHolder) === false;
    const isAccountHolderTooLong = maxLength(32)(accountHolder) === false;

    const bsbNumberNZTooltip = messages.bsbNumberNZTooltip.defaultMessage;
    const accountNumberNZTooltip = messages.accountNumberNZTooltip.defaultMessage;
    return (
      <div>
        <div className={'row'}>
          <div className={'col'}>
            <P>
              <FormattedMessage {...messages.depositMessage} />
            </P>
            <P style={{ fontWeight: 'bold', marginTop: 10, marginBottom: 10 }}>
              <FormattedMessage {...messages.pleaseNote} />
            </P>
            <ul style={{ margin: 0 }}>
              <li>
                <FormattedMessage
                  {...messages.weCannotDepositIntoACreditCardAccount}
                />
              </li>
            </ul>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-8 form-group mb02'}>
            <Validate
              name="accountHolder"
              group={this.validatorGroup}
              validators={[required, alphaHyphenOnly, maxLength(32)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.accountHolder}
              tooltipContent={intl.formatMessage(messages.bankAccountNameTooltip)}
              tooltipDataFor={'accountHolderHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly}
                name="accountHolder"
                type="text"
                onChange={this.handleChange('form.accountHolder')}
                value={accountHolder}
                placeholder={isFnolNewZealand ? messages.accountNamePlaceholder.defaultMessage : null}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.accountHolder) }}
                />
              </ErrorMessage>
            </Validate>
            {isAccountHolderTooLong ? (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.limitAccountNameCharacters} />
              </P>
            ) : isInvalidAccountHolderFormat && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.onlyAlphaHyphenAllowed} />
              </P>
            )}
          </div>
        </div>

        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="bsbNumber"
              group={this.validatorGroup}
              validators={[required, length(6)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={isFnolNewZealand ? messages.bsbNumberNZ : messages.bsbNumber}
              tooltipContent={isFnolNewZealand ? bsbNumberNZTooltip : null}
              tooltipDataFor={'bankCodeHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly || bsbValidating}
                name="bsbNumber"
                type="number"
                onBlurCapture={this.getBankByBsb}
                onChange={this.handleChange('form.bsbNumber')}
                value={bsbNumber}
                placeholder={isFnolNewZealand ? messages.bsbNumberNZPlaceholder.defaultMessage : null}
              />
              <ErrorMessage for="required">
                {/* &apos;BSB Number&apos; is required */}
                <FormattedMessage
                  {...messages.isRequired}
                  values={{
                    defaultMessage: intl.formatMessage(
                      isFnolNewZealand ? messages.bsbNumberNZ : messages.bsbNumber
                    ),
                  }}
                />
              </ErrorMessage>
              <ErrorMessage for="m_length">
                <FormattedMessage {...messages.bsbNumberLengthValidation} />
              </ErrorMessage>
            </Validate>
            {(!isbsbNumber6Digits && bsbNumber) && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage
                  {...messages.bsbNumberLengthValidation}
                  values={{ type: isFnolNewZealand ? messages.bsbNumberNZ.defaultMessage : messages.bsbNumber.defaultMessage }}
                />
              </P>
            )}
          </div>
          <div
            className={'col-md-8 form-group mb02'}
            style={{
              justifyContent: 'flex-end',
              flexDirection: 'column',
              display: 'flex',
            }}
          >
            <OptionsContainer>
              <input
                disabled={isReadOnly || isBsbValid || !bsbNumber}
                type="checkbox"
                name="bsbCannotBeVerified"
                checked={bsbCannotBeVerified}
                onChange={this.handleChange('form.bsbCannotBeVerified')}
              />
              <span>
                {isFnolNewZealand ? (
                  <FormattedMessage {...messages.bsbCannotBeVerifiedNZ} />
                ) : (
                  <FormattedMessage {...messages.bsbCannotBeVerified} />
                )}
              </span>
            </OptionsContainer>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="nameOfBank"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={nameOfBank}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.nameOfBank}
            >
              <Textbox
                disabled={
                  isReadOnly ||
                  isBsbValid ||
                  (!isBsbValid && !bsbCannotBeVerified)
                }
                name="nameOfBank"
                type="text"
                onChange={this.handleChange('form.nameOfBank')}
                value={nameOfBank}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.nameOfBank) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.branch} />
            </PageSectionHeader>
            <Textbox
              disabled={
                isReadOnly ||
                isBsbValid ||
                (!isBsbValid && !bsbCannotBeVerified)
              }
              name="branch"
              type="text"
              onChange={this.handleChange('form.branch')}
              value={branch}
            />
          </div>
        </div>

        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="accountNumber"
              group={this.validatorGroup}
              validators={[required, maxLength(maxAccountNumberLength), ...isFnolNewZealand ? [minLength(9)] : []]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={isFnolNewZealand ? messages.accountNumberNZ : messages.accountNumber}
              tooltipContent={isFnolNewZealand ? accountNumberNZTooltip : null}
              tooltipDataFor={'accountNumberHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly}
                name="accountNumber"
                type="number"
                onChange={this.handleChange('form.accountNumber')}
                value={accountNumber}
                onlyNumber
                placeholder={isFnolNewZealand ? messages.accountNumberNZPlaceholder.defaultMessage : null}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{
                    defaultMessage: intl.formatMessage(
                      isFnolNewZealand ? messages.accountNumberNZ : messages.accountNumber
                    ),
                  }}
                />
              </ErrorMessage>
            </Validate>
            {isAccountNumberTooLong && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage
                  {...messages.accountNumberLengthValidation}
                  values={{ maxLength: maxAccountNumberLength }}
                />
              </P>
            )}
            {(isAccountNumberTooShort && accountNumber) && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                {isFnolNewZealand ? (
                  <FormattedMessage {...messages.accountNumberNZLengthValidationWithSuffix} />
                ) : (
                  <FormattedMessage {...messages.accountNumberLengthValidationWithSuffix} />
                )}
              </P>
            )}
          </div>
        </div>

        {isShowGstQuestion && (<div>
          <div className={'row mt-3'}>
            <div className={'col-12 form-group mb02'}>
              <span style={{ fontWeight: 'bold', fontSize: '0.86em' }}>
                <FormattedMessage {...messages.GSTInfo} />
              </span>
            </div>
          </div>

          <div className={'row mb-2'}>
            <div className={'col-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouRegisteredForGTSPurposes} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={registerForGSTPurpose === 'true'}
                    onChange={this.handleChange('form.registerForGSTPurpose')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={registerForGSTPurpose === 'false'}
                    onChange={this.handleResetPartialFormState(
                      'form.registerForGSTPurpose',
                      this.props.onResetRegisterGstState
                    )}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        </div>)}

        {!isClaimForFieldEnabled && this.renderRegisterdGSTPurpuseInfo()}
        {!isClaimForFieldEnabled && (
          <div className={'form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.doYouHaveAnotherOtherInsurance} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={otherInsurance === 'true'}
                  onChange={this.handleChange('form.otherInsurance')}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={otherInsurance === 'false'}
                  onChange={(event) => {
                    this.handleChange('form.otherInsurance')(event);
                    this.props.onFormDataChange('form.provideDetails', '');
                    this.props.setFormHasChanges(true);
                  }}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
            <HelpText>
              <FormattedMessage {...messages.exampleHomeContentsInsurance} />
            </HelpText>
          </div>
        )}
        {!isClaimForFieldEnabled && this.renderOtherInsuranceDetail()}
      </div>
    );
  }

  renderTugoBankDetailsForm() {
    const {
      isSummary,
      submitted,
      bsbValidating,
      cellCaptiveCountryId,
      policyTypeCode,
      isClaimForFieldEnabled,
      isShowGstQuestion,
      intl,
    } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      nameOfBank,
      branch,
      bsbNumber,
      institutionNumber,
      accountNumber,
      accountHolder,
      registerForGSTPurpose,
      otherInsurance,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { bsbCannotBeVerified, isBsbValid } = this.props.form;

    const isPartnerInsurance = listPolicyTypeForCellCaptivePartnerInsurance.includes(policyTypeCode);
    const isFnolNewZealand = cellCaptiveCountryId === SCTI_COUNTRY_IDS.NEW_ZEALAND || isPartnerInsurance;

    const isTransitNumberValidLength = length(5)(bsbNumber);
    const isInstitutionNumberValidLength = length(3)(institutionNumber);

    const maxAccountNumberLength = 12;
    const minAccountNumberLength = 7;
    const isAccountNumberTooLong = maxLength(maxAccountNumberLength)(accountNumber) === false;
    const isAccountNumberTooShort = minLength(minAccountNumberLength)(accountNumber) === false;

    const isInvalidAccountHolderFormat = alphaOnly(accountHolder) === false;
    const isAccountHolderTooLong = maxLength(32)(accountHolder) === false;

    const bsbNumberNZTooltip =
      'The first 6 digits of your bank account which captures your bank`s prefix and branch number (e.g. 123113).';
    const accountNumberNZTooltip =
      'Your unique number and suffix (usually 9-10 digits)';
    return (
      <div>
        <div className={'row'}>
          <div className={'col'}>
            <P>
              <FormattedMessage {...messages.depositMessage} />
            </P>
            <P style={{ fontWeight: 'bold', marginTop: 10, marginBottom: 10 }}>
              <FormattedMessage {...messages.pleaseNote} />
            </P>
            <ul style={{ margin: 0 }}>
              <li>
                <FormattedMessage
                  {...messages.weCannotDepositIntoACreditCardAccount}
                />
              </li>
            </ul>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-8 form-group mb02'}>
            <Validate
              name="accountHolder"
              group={this.validatorGroup}
              validators={[required, alphaOnly, maxLength(32)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.accountHoldersName}
              tooltipContent={intl.formatMessage({ id: 'fastCover.stepAppsureBankDetails.bankAccountNameTooltip' })}
              tooltipDataFor={'accountHolderHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly}
                name="accountHolder"
                type="text"
                onChange={this.handleChange('form.accountHolder')}
                value={accountHolder}
                placeholder={isFnolNewZealand ? messages.accountNamePlaceholder.defaultMessage : null}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.accountHoldersName) }}
                />
              </ErrorMessage>
              <ErrorMessage for={alphaOnly}>
                <FormattedMessage {...messages.onlyAlphaCharactersAllowed} />
              </ErrorMessage>
            </Validate>
            {isAccountHolderTooLong ? (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.limitAccountNameCharacters} />
              </P>
            ) : isInvalidAccountHolderFormat && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.onlyAlphaCharactersAllowed} />
              </P>
            )}
          </div>
        </div>

        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="bsbNumber"
              group={this.validatorGroup}
              validators={[required, minLengthAllowEmpty(5), maxLengthAllowEmpty(5)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.transitNumber}
              tooltipContent={isFnolNewZealand ? bsbNumberNZTooltip : null}
              tooltipDataFor={'bankCodeHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly || bsbValidating}
                name="bsbNumber"
                type="number"
                onBlurCapture={this.getBankByTransitAndInstitution}
                onChange={this.handleChange('form.bsbNumber')}
                value={bsbNumber}
                placeholder={isFnolNewZealand ? messages.bsbNumberNZPlaceholder.defaultMessage : null}
                onlyNumber
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.transitNumber) }}
                />
              </ErrorMessage>
            </Validate>
            {(!isTransitNumberValidLength && bsbNumber) && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.transitNumberValidation} />
              </P>
            )}
          </div>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="institutionNumber"
              group={this.validatorGroup}
              validators={[required, minLengthAllowEmpty(3), maxLengthAllowEmpty(3)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.institutionNumber}
            >
              <Textbox
                disabled={isReadOnly || bsbValidating}
                name="institutionNumber"
                type="number"
                onBlurCapture={this.getBankByTransitAndInstitution}
                onChange={this.handleChange('form.institutionNumber')}
                value={institutionNumber}
                onlyNumber
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.institutionNumber) }}
                />
              </ErrorMessage>
            </Validate>
            {(!isInstitutionNumberValidLength && institutionNumber) && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.institutionNumberValidation} />
              </P>
            )}
          </div>
        </div>

        <div className="row">
          <div
            className="col-md-6 col-sm-6 form-group mb02 d-flex align-items-center"
            style={{ gap: 8 }}
          >
            <OptionsContainer style={{ marginBottom: 0 }}>
              <input
                disabled={isReadOnly || isBsbValid || !bsbNumber}
                type="checkbox"
                name="bsbCannotBeVerified"
                checked={bsbCannotBeVerified}
                onChange={this.handleChange('form.bsbCannotBeVerified')}
              />
              <span>
                <FormattedMessage {...messages.transitAndInstitutionCannotBeVerified} />
              </span>
            </OptionsContainer>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="nameOfBank"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={nameOfBank}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.nameOfBank}
            >
              <Textbox
                disabled={
                  isReadOnly ||
                  isBsbValid ||
                  (!isBsbValid && !bsbCannotBeVerified)
                }
                name="nameOfBank"
                type="text"
                onChange={this.handleChange('form.nameOfBank')}
                value={nameOfBank}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.nameOfBank) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.branch} />
            </PageSectionHeader>
            <Textbox
              disabled={
                isReadOnly ||
                isBsbValid ||
                (!isBsbValid && !bsbCannotBeVerified)
              }
              name="branch"
              type="text"
              onChange={this.handleChange('form.branch')}
              value={branch}
            />
          </div>
        </div>

        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="accountNumber"
              group={this.validatorGroup}
              validators={[required, minLengthAllowEmpty(minAccountNumberLength), maxLengthAllowEmpty(maxAccountNumberLength)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.accountNumber}
              tooltipContent={isFnolNewZealand ? accountNumberNZTooltip : null}
              tooltipDataFor={'accountNumberHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly}
                name="accountNumber"
                type="number"
                onChange={this.handleChange('form.accountNumber')}
                value={accountNumber}
                onlyNumber
                placeholder={isFnolNewZealand ? messages.accountNumberNZPlaceholder.defaultMessage : null}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.accountNumber) }}
                />
              </ErrorMessage>
            </Validate>
            {isAccountNumberTooShort && accountNumber && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.accountNumberMinValidation} />
              </P>
            )}
            {isAccountNumberTooLong && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.accountNumberMaxValidation} />
              </P>
            )}
          </div>
        </div>

        {isShowGstQuestion && (<div>
          <div className={'row mt-3'}>
            <div className={'col-12 form-group mb02'}>
              <span style={{ fontWeight: 'bold', fontSize: '0.86em' }}>
                <FormattedMessage {...messages.GSTInfo} />
              </span>
            </div>
          </div>

          <div className={'row mb-2'}>
            <div className={'col-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouRegisteredForGTSPurposes} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={registerForGSTPurpose === 'true'}
                    onChange={this.handleChange('form.registerForGSTPurpose')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={registerForGSTPurpose === 'false'}
                    onChange={this.handleResetPartialFormState(
                      'form.registerForGSTPurpose',
                      this.props.onResetRegisterGstState
                    )}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        </div>)}

        {!isClaimForFieldEnabled && this.renderRegisterdGSTPurpuseInfo()}
        {!isClaimForFieldEnabled && (
          <div className={'form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.doYouHaveAnotherOtherInsurance} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={otherInsurance === 'true'}
                  onChange={this.handleChange('form.otherInsurance')}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={otherInsurance === 'false'}
                  onChange={(event) => {
                    this.handleChange('form.otherInsurance')(event);
                    this.props.onFormDataChange('form.provideDetails', '');
                    this.props.setFormHasChanges(true);
                  }}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
            <HelpText>
              <FormattedMessage {...messages.exampleHomeContentsInsurance} />
            </HelpText>
          </div>
        )}
        {!isClaimForFieldEnabled && this.renderOtherInsuranceDetail()}
      </div>
    );
  }

  render() {
    const {
      isSummary,
      submitted,
      loading,
      showBSBNotice,
      cellCaptiveCountryId,
      policyTypeCode,
      cellCaptiveName,
      intl,
    } = this.props;
    const { showModal } = this.state;
    const isPartnerInsurance = listPolicyTypeForCellCaptivePartnerInsurance.includes(policyTypeCode);
    const isFnolNewZealand = cellCaptiveCountryId === SCTI_COUNTRY_IDS.NEW_ZEALAND || isPartnerInsurance;
    const isVisitorsToCanada = cellCaptiveName === LIST_CELLCAPTIVE_NAME.CELL_CAPTIVE_NAME_VISITORS_TO_CANADA;
    return (
      <div className="app-content">
        {isVisitorsToCanada ? this.renderTugoBankDetailsForm() : this.renderBankDetailsForm()}
        {!isSummary && (
          <WizardNavigationButtons
            onBack={this.props.prev}
            onNext={this.handleNext}
            onSave={this.handleSaveButtonClick}
            canMoveNext={true}
            listLength={1}
            submitted={submitted}
            loading={loading}
            saveButtonId={this.saveButtonId}
            showSpinnerForElement={this.showSpinnerForElement}
            handleKeyDown={this.handleKeyDown}
            intl={intl}
            hasFormChanges={this.props.hasFormChanges}
            nextButtonRef={(ref) => {
              this.nextButton = ref;
            }}
          />
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
        <ModalNotice
          isFnolNewZealand={isFnolNewZealand}
          isOpen={showBSBNotice}
          onClose={this.props.closeBSBNotice}
          useTransitNotice={isVisitorsToCanada}
        />
        <InvalidBSBWarning isOpen={showModal} onClose={this.closeModal} />
      </div>
    );
  }
}

StepAppsureBankDetails.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  onResetRegisterGstState: PropTypes.func,
  currentStep: PropTypes.number,
  step: PropTypes.number,
  isReadOnly: PropTypes.bool,
  loading: PropTypes.bool,
  errors: PropTypes.array,
  adjust: PropTypes.func,
  onNext: PropTypes.func,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  submitted: PropTypes.bool,
  isSummary: PropTypes.bool,
  bsbValidating: PropTypes.bool,
  onGetBankByBSB: PropTypes.func,
  showBSBNotice: PropTypes.bool,
  closeBSBNotice: PropTypes.func,
  getBankSuccess: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  cellCaptiveCountryId: PropTypes.number,
  policyTypeCode: PropTypes.string,
  isClaimForFieldEnabled: PropTypes.bool,
  isShowGstQuestion: PropTypes.bool,
  cellCaptiveName: PropTypes.string,
  intl: intlShape.isRequired,
};

const mapStateToProps = createStructuredSelector({
  currentStep: makeSelectCurrentStep(),
  form: makeSelectStepAppsureBankDetails(),
  errors: makeSelectStepAppsureBankDetailsErrors(),
  loading: makeSelectProgressBarStatus(),
  bsbValidating: makeSelectBsbValidating(),
  showBSBNotice: makeSelectBsbNotice(),
  cellCaptiveCountryId: makeSelectCellCaptiveCountryId(),
  policyTypeCode: makeSelectPolicyTypeCode(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  isShowGstQuestion: makeSelectIsShowGstQuestion(),
  cellCaptiveName: makeSelectCellCaptiveName(),
  hasFormChanges: makeSelectFormHasChanges(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetRegisterGstState: () => dispatch(resetFormRegisterGstState()),
  onGetBankByBSB: (bsb) => dispatch(getBank(bsb)),
  closeBSBNotice: () => dispatch(closeBSBNotice()),
  getBankSuccess: (bankInfo) => dispatch(getBankSuccess(bankInfo)),
  setFormHasChanges: (hasFormChanges) => dispatch(setFormHasChanges(hasFormChanges)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepAppsureBankDetails', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl,
)(StepAppsureBankDetails);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/index.js